import { Grid, IconButton } from '@material-ui/core';
import { MdDelete } from '@WESCO-International/react-svg-icons/md/MdDelete';
import { Input } from '@WESCO-International/wdp-ui-components/components/input';
import type { LinkInput } from '../common/types';

interface LinksSectionProps {
  links: LinkInput[];
  maxLinks: number;
  onAdd: () => void;
  onRemove: (index: number) => void;
  onUpdate: (index: number, patch: Partial<LinkInput>) => void;
}

export const LinksSection = ({
  links,
  maxLinks,
  onAdd,
  onRemove,
  onUpdate,
}: LinksSectionProps) => {
  const canAdd = links.length < maxLinks;

  return (
    <div className="formSection">
      <div className="links-header">
        <h6 className="wdp-heading s-6 semibold links-title">Links</h6>
        <IconButton
          aria-label="Add link"
          onClick={onAdd}
          disabled={!canAdd}
          size="small"
          className="links-add-btn"
        >
          <span className="links-add-icon">+</span>
        </IconButton>
      </div>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <div className="formRow">
            {links.map((link, idx) => (
              <Grid container spacing={1} key={idx} alignItems="flex-start">
                <Grid item xs={12} md={6}>
                  <Input
                    value={link.url}
                    onChange={e =>
                      onUpdate(idx, {
                        url: (e.target as HTMLInputElement).value,
                      })
                    }
                    placeholder="URL"
                    isize="normal"
                  />
                </Grid>

                <Grid item xs={12} md={links.length > 1 ? 3 : 6}>
                  <Input
                    value={link.title}
                    onChange={e =>
                      onUpdate(idx, {
                        title: (e.target as HTMLInputElement).value,
                      })
                    }
                    placeholder="Title"
                    isize="normal"
                  />
                </Grid>

                {links.length > 1 && (
                  <Grid item xs={12} md={3}>
                    <div className="links-remove-wrap">
                      <IconButton
                        aria-label="Remove link"
                        onClick={() => onRemove(idx)}
                        color="default"
                      >
                        <MdDelete className="links-remove-icon" />
                      </IconButton>
                    </div>
                  </Grid>
                )}
              </Grid>
            ))}

            {!canAdd && (
              <div className="links-max-note">
                Maximum of {maxLinks} links reached.
              </div>
            )}
          </div>
        </Grid>
      </Grid>
    </div>
  );
};
